import React, { useEffect } from "react";
import { observer } from "mobx-react";
import dashboardStore from "../../../store/dashboardStore";
import styles from "../../../styles/intensity.module.css";
import loadingSvg from "../../../../Assets/images/tube-spinner.svg";
import { useTranslation } from "react-i18next";
import { SubPageSwitch } from "../SubPageSwitch";
import { MatricCard } from "./MatricCard";
import { Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { DeleteWarningModal } from "../../../modals/DeleteWarningModal";
import { useActiveEditor } from "../../../../hooks/useActiveEditor";

export const Intensity = observer(() => {
  const store = dashboardStore;
  const { t } = useTranslation("ActivityMain");

  const initial = async () => {
    store._handleClearMetric();
    await store.getIntensityDefaultScope();
    await store.getAllIntensityData();
  };

  useEffect(() => {
    initial();
  }, []);

  ////////註冊這個頁面需要用到的save fn
  useActiveEditor({
    store,
    isEdit: () => store.dashboardIsEdit,
    openWarning: () => {
      store._handleSetShowDashboardWarningModal(true);
    },
    save: async () => {
      return await store.updateIntensityData();
    },
    clearEdit: () => {
      store._handleSetDashboardIsEdit(false);
    },
  });

  return (
    <div
      className={`${styles.intensityContainer} ${
        store.isIntensityLoading ? styles.loadingActive : ""
      }`}
    >
      {store.isIntensityLoading && (
        <div className={styles.loading}>
          <img
            className={styles.loadingImg}
            src={loadingSvg}
            alt="loadingSvg"
          />
        </div>
      )}
      <div className={styles.main}>
        <SubPageSwitch />{" "}
        <div className={styles.metricHeader}>
          <div className={styles.metricInfo}>
            <h3 className={styles.metricTitle}>{t("Emission Intensity")}</h3>
            <p className={styles.metricDescription}>
              {t(
                "Add a metric, then enter the emissions data (not sourced from NxMap) and the corresponding denominators",
              )}
            </p>
          </div>

          <div className={styles.infoBtnWrap}>
            {store.metricData.length >= 9 ? (
              <Tooltip
                className={styles.tooltip}
                title={t("A maximum of 9 metrics can be added.")}
                slotProps={{
                  tooltip: {
                    sx: {
                      fontSize: "14px",
                    },
                  },
                }}
              >
                <InfoIcon className={styles.infoIcon} />
              </Tooltip>
            ) : null}
            <button
              className={styles.addMetricBtn}
              onClick={() => store._handleCreateMetric()}
              disabled={
                store.metricData.length >= 9 || store.intensityIsLoading
              }
            >
              + {t("Add Metric")}
            </button>
          </div>
        </div>
        <div className={styles.metricWrapper}>
          {store.metricData.map((card, index) => (
            <MatricCard key={index} card={card} index={index} />
          ))}
        </div>
      </div>

      {store.showDeleteWarningModal === true ? <DeleteWarningModal /> : null}
    </div>
  );
});
